import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { ToolbarComponent } from './toolbar/toolbar.component';
import { NavbarComponent } from './navbar/navbar.component';
import { Authorization } from './authorization/authorization.component';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AboutModule } from '../about/about.module';
import { LoadingOverlayComponent } from './loading/loading-overlay.component';
import { LoadingButtonDirective } from './loading/loading-button.directive';
import { LoadingService } from './common/LoadingService';

// Digital Signing Components and Services
import { DigitalSignerModalComponent } from './components/digital-signer-modal/digital-signer-modal.component';

// Signing-method primitives
import { SegmentedControlComponent } from './components/segmented-control/segmented-control.component';
import { ToggleRowComponent } from './components/toggle-row/toggle-row.component';
import { MethodBadgeComponent } from './components/method-badge/method-badge.component';
import { ChipComponent } from './components/chip/chip.component';
import { ChipGroupComponent } from './components/chip-group/chip-group.component';

// Disclosure consent gate
import { MarkdownViewComponent } from './components/markdown-view/markdown-view.component';
import { DisclosureConsentComponent } from './components/disclosure-consent/disclosure-consent.component';
import { DisclosureModalComponent } from './components/disclosure-modal/disclosure-modal.component';

/**
 * Do not specify providers for modules that might be imported by a lazy loaded module.
 */

export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient);
}

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    AboutModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  declarations: [
    ToolbarComponent,
    NavbarComponent,
    LoadingOverlayComponent,
    LoadingButtonDirective,
    DigitalSignerModalComponent,
    SegmentedControlComponent,
    ToggleRowComponent,
    MethodBadgeComponent,
    ChipComponent,
    ChipGroupComponent,
    MarkdownViewComponent,
    DisclosureConsentComponent,
    DisclosureModalComponent
  ],
  exports: [
    ToolbarComponent,
    NavbarComponent,
    LoadingOverlayComponent,
    LoadingButtonDirective,
    DigitalSignerModalComponent,
    SegmentedControlComponent,
    ToggleRowComponent,
    MethodBadgeComponent,
    ChipComponent,
    ChipGroupComponent,
    MarkdownViewComponent,
    DisclosureConsentComponent,
    DisclosureModalComponent,
    CommonModule,
    FormsModule,
    RouterModule,
    TranslateModule
  ]
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: []
    };
  }
}
